import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safe-html/safe-html';
import { PricePipe } from './price/price';
import { SafeIframePipe } from './safe-iframe/safe-iframe';
@NgModule({
	declarations: [SafeHtmlPipe,
    PricePipe,
    SafeIframePipe],
	imports: [],
	exports: [SafeHtmlPipe,
    PricePipe,
    SafeIframePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts